import { Box, Button, Typography } from '@mui/material'
import { Event as EventIcon } from '@mui/icons-material'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { ROUTES } from '@/utils/constants'
import { formatLessonClock } from '@/utils/date'
import type { WidgetProps } from './WidgetProps'
import { EmptyHint } from './EmptyHint'

interface LessonPayload {
  id: number
  planned_start_at: string | null
  teacher?: { display_name?: string } | null
}

interface ThemePayload {
  id: number
  position: number
  /** null — политика видимости назначения прячет заголовок будущей темы */
  title: string | null
}

export function NextLessonWidget({ payload }: WidgetProps) {
  const { t } = useTranslation()
  const lesson = (payload.lesson ?? null) as LessonPayload | null
  const theme = (payload.theme ?? null) as ThemePayload | null

  if (!lesson) {
    return (
      <EmptyHint
        hint={typeof payload.hint === 'string' ? payload.hint : undefined}
        fallbackKey="dashboard.widgets.next_lesson.empty"
      />
    )
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap' }}>
      <EventIcon color="primary" fontSize="large" />
      <Box sx={{ flexGrow: 1, minWidth: 0 }}>
        <Typography variant="h6" fontWeight={700}>
          {formatLessonClock(lesson.planned_start_at, { withDate: true })}
        </Typography>
        {lesson.teacher?.display_name && (
          <Typography variant="body2" color="text.secondary" noWrap>
            {lesson.teacher.display_name}
          </Typography>
        )}
        {/* Анонс темы: «в четверг — тема 9». Заголовок может быть закрыт
            политикой видимости — тогда говорим только, что тема выбрана */}
        {theme && (
          <Typography variant="body2" color="text.secondary" noWrap>
            {theme.title
              ? t('programs.announcement.theme', {
                  position: theme.position + 1,
                  title: theme.title,
                })
              : t('programs.announcement.hidden')}
          </Typography>
        )}
      </Box>
      <Button size="small" component={Link} to={ROUTES.LESSON_DETAILS(lesson.id)}>
        {t('dashboard.widgets.next_lesson.open')}
      </Button>
    </Box>
  )
}
